import { createFileRoute } from "@tanstack/react-router";

import { PraxaAutomationDetail } from "../components/praxa/PraxaAutomationCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/schedule/$automationId")({
  component: PraxaScheduleDetailRoute,
});

function PraxaScheduleDetailRoute() {
  const { workspaceId, automationId } = Route.useParams();
  return (
    <PraxaAutomationDetail automationId={automationId} view="schedule" workspaceId={workspaceId} />
  );
}
